import { apiClient } from '../client';

/**
 * Client for `/api/comms/unread` — the one cheap endpoint the AppShell
 * headers poll every 30s to drive the notification pills (Stream E,
 * ADR-027 §3.5). Kept 1:1 with `server/src/routes/comms/unread.routes.ts`.
 */

export interface CommsUnread {
  chat: { totalUnread: number; conversationsWithUnread: number };
  announcements: { unread: number; unacknowledged: number };
}

/** Shared query key — the header hook polls it; mutations invalidate it. */
export const COMMS_UNREAD_KEY = ['comms', 'unread'] as const;

export async function getCommsUnread(): Promise<CommsUnread> {
  const res = await apiClient.get<{ data: CommsUnread }>('/api/comms/unread');
  return res.data.data;
}
